import englishWidgetMessages from 'devextreme/localization/messages/en.json' with { type: 'json' };
import turkishWidgetMessages from 'devextreme/localization/messages/tr.json' with { type: 'json' };
import englishAnalyticsMessages from './devexpress/dx-analytics.en.json' with { type: 'json' };
import turkishAnalyticsMessages from './devexpress/dx-analytics.tr.json' with { type: 'json' };
import englishReportingMessages from './devexpress/dx-reporting.en.json' with { type: 'json' };
import turkishReportingMessages from './devexpress/dx-reporting.tr.json' with { type: 'json' };
import { normalizeReportingLocale } from './reporting-messages.js';

const WIDGET_MESSAGES = {
    en: englishWidgetMessages,
    tr: turkishWidgetMessages,
};

const WEB_REPORTING_MESSAGES = {
    en: [englishAnalyticsMessages, englishReportingMessages],
    tr: [turkishAnalyticsMessages, turkishReportingMessages],
};

export function configureDevExpressLocalization(event, locale) {
    const normalized = normalizeReportingLocale(locale);
    const args = event?.args ?? event;
    WEB_REPORTING_MESSAGES[normalized].forEach((messages) => args?.LoadMessages?.(messages));

    const widgetLocalization = args?.WidgetLocalization;
    if (widgetLocalization) {
        widgetLocalization.loadMessages(WIDGET_MESSAGES[normalized]);
        widgetLocalization.locale(normalized);
    }
}
